module.exports = __webpack_public_path__ + "static/media/ydch.74ad3633.jpg";